// extracted by mini-css-extract-plugin
module.exports = {"resultWrap":"resultWrap_1yrVzIV8","statusImg":"statusImg_1195Iq-2","btn":"btn_20N4rNTt","btnDefault":"btnDefault_kJhgTyIl"};